import { Link } from '@tanstack/react-router';
import { useTheme } from '@mui/material/styles';

export const NotFound = () => {
    const theme = useTheme()
        
    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <p style={{textAlign: 'center' }}>
                <h2 style={{color: theme.palette.primary.main }}>404 Not Found.</h2>
                <Link to="/">Back to home</Link>
            </p>
        </div>
    );
}